<div class="header">
	<div class="title">
		{{ title }}
		<ng-content select="[modal-wrapper-additional-title]"></ng-content>
	</div>
	<div class="filters">
		<ng-content select="[modal-wrapper-header-action]"></ng-content>
		<mat-icon (click)="closeModal.emit()" class="close-action" aria-label="Close">close</mat-icon>
	</div>
</div>

<div class="content" [ngClass]="contentClass">
	<ng-content select="[modal-wrapper-content]"></ng-content>
</div>

<div class="actions-container" [ngClass]="actionsPanelClass">
	<ng-content select="[modal-wrapper-actions]"></ng-content>
</div>
